import {
  Button,
  Col,
  FormControl,
  FormGroup,
  Modal,
  Row,
} from 'react-bootstrap';
import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { useState } from 'react';
import IntlTelInputApp from '../../../../intlTelInputCustome/IntlTelInputApp';
import {
  CCLiteCommonFunc,
  trimPhoneNumber,
  Validation,
} from '../../../../../utils/commonFunctions';
import { Validator, ValidCase } from '../../../../validator';
import PropTypes from 'prop-types';
import { TRAVELER_TYPE } from '../../../../../constants/commondata';
const AddNewCustomer = ({ 
  closeModal,
  newbookingActions,
  corporateActions,
  selectedFleet,
  onAddNewCustomerSucccess,
  traveler_type,
  corporateId
}, context) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [valid, setValid] = useState();
  const [formData, setFormData] = useState({
    phone: '',
    firstName: '',
    lastName: '',
    email: '',
  });

  const handlePhoneChange = (
    status,
    value,
    countryData,
    number,
    id,
    isBlur
  ) => {
    setFormData({
      ...formData,
      phone: number,
    });
    setValid({
      ...valid,
      phone: status,
    });
  };

  const submitAddPax = async () => {
    setIsSubmitted(true)
    if (!CCLiteCommonFunc.isFormValid(valid)) {
      return;
    }
    const params = {
      fleetId: selectedFleet?.fleetId,
      phone: trimPhoneNumber(formData.phone),
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
    }
    const isCorpUser = traveler_type == TRAVELER_TYPE.Corporate && corporateId;
    if(isCorpUser) {
      params.corporateId = corporateId;
      params.phoneNumber = params.phone;
      params.active = true;
      params.isAirline = false;
    }

    try {
      const result = isCorpUser ? await newbookingActions.createTravelerWhenNewBooking(params) : await newbookingActions.createWithBooking(params)
      if(result?.res?._id) {
        context.notification('success', I18n.t('customer.Add_customer_success')); 
        onAddNewCustomerSucccess(result?.res);
        closeModal();
      } else if(result?.error?.errorCode) {
        context.notification('error', I18n.t(`errors.${result.error.errorCode}`));
      } else {
        context.notification('error', I18n.t('customer.Create_customer_fail'));
      }
    } catch (error) {
      console.error('Error creating customer:', error);
      context.notification('error', I18n.t('customer.Create_customer_fail'));
    }
  };

  const handleFormDataChange = (key, e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const ValidatorCallback = (id, isValid, messages) => {
    setValid((prevValid) => {
      if (prevValid?.[id] !== isValid) {
        return {
          ...prevValid,
          [id]: isValid,
        };
      }
      return prevValid;
    });
  };

  return (
    <Modal
      show={true}
      backdrop={false}
      dialogClassName="confirm-dialog add-new-customer"
      onHide={closeModal}
      className={'confirm modal-custom-header'}
      size={'sm'}
    >
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('newbooking.newCustomer')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} md={12}>
            <FormGroup
              className={!isSubmitted ? null : valid.phone ? null : 'error'}
            >
              <IntlTelInputApp
                css={['intl-tel-input', 'form-control']}
                utilsScript="libphonenumber.js"
                value={formData.phone}
                onPhoneNumberChange={(
                  status,
                  value,
                  countryData,
                  number,
                  id
                ) => {
                  handlePhoneChange(status, value, countryData, number, id);
                }}
              />
              <Validator id="phone" callback={ValidatorCallback}>
                <ValidCase
                  hide={!isSubmitted}
                  valid={!Validation.isStringEmpty(formData.phone)}
                  message={I18n.t('messages.commonMessages.Required_field')}
                />
                {/* <ValidCase
                  hide={!isSubmitted}
                  valid={valid?.phone}
                  message={I18n.t('customer.ERROR_INPUT_VALIDPHONE')}
                /> */}
                {/* <ValidCase
                  hide={!isSubmitted}
                  valid={true}
                  message={I18n.t('customer.ERROR_EXISTED_PHONE')}
                /> */}
              </Validator>
            </FormGroup>
          </Col>
          <Col xs={12} md={6}>
            <FormGroup
              className={!isSubmitted ? null : valid.firstName ? null : 'error'}
            >
              <FormControl
                className="form-custom"
                type="text"
                value={formData.firstName || ''}
                onChange={(e) => handleFormDataChange('firstName', e)}
                placeholder={I18n.t('bookingdetail.First_name')}
              />
              <Validator id="firstName" callback={ValidatorCallback}>
                <ValidCase
                  hide={!isSubmitted}
                  valid={!Validation.isStringEmpty(formData.firstName)}
                  message={I18n.t('messages.commonMessages.Required_field')}
                />
              </Validator>
            </FormGroup>
          </Col>
          <Col xs={12} md={6}>
            <FormGroup
              className={!isSubmitted ? null : valid.lastName ? null : 'error'}
            >
              <FormControl
                className="form-custom"
                type="text"
                value={formData.lastName || ''}
                onChange={(e) => handleFormDataChange('lastName', e)}
                placeholder={I18n.t('bookingdetail.Last_name')}
              />
              <Validator id="lastName" callback={ValidatorCallback}>
                <ValidCase
                  hide={!isSubmitted}
                  valid={!Validation.isStringEmpty(formData.lastName)}
                  message={I18n.t('messages.commonMessages.Required_field')}
                />
              </Validator>
            </FormGroup>
          </Col>
          <Col xs={12} md={12}>
            <FormGroup
              className={!isSubmitted ? null : valid.email ? null : 'error'}
            >
              <FormControl
                className="form-custom"
                type="text"
                value={formData.email || ''}
                onChange={(e) => handleFormDataChange('email', e)}
                placeholder={I18n.t('bookingdetail.Email_address')}
              />
              <Validator id="email" callback={ValidatorCallback}>
                <ValidCase
                  hide={!isSubmitted}
                  valid={Validation.validateEmail(formData.email)}
                  message={I18n.t(
                    'messages.commonMessages.invalid_email_format'
                  )}
                />
              </Validator>
            </FormGroup>
          </Col>
        </Row>
        <div className="btnBottom">
          <Button className="btn-header text-add-header mr-r-10" onClick={closeModal}>
            <Translate value="bookingdetail.Cancel" />
          </Button>
          <Button
            className="btn-save view-button"
            onClick={submitAddPax}
            disabled={false}
          >
            <Translate value="bookingdetail.Save" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
AddNewCustomer.contextTypes = {
  notification: PropTypes.func,
};
export default AddNewCustomer;
